import { Flex } from '@talos/kyoko';
import styled from 'styled-components';
import { MarketTag } from '../styles';

export const MarketListWrapper = styled.div`
  width: 100%;

  .markets-list {
    flex: 1;
    align-items: center;
    gap: ${({ theme }) => theme.spacing4}px;
    overflow: hidden;
    width: 100%;
  }
`;

export const MarketsOverflowWrapper = styled(Flex)`
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing4}px;
  width: 200px;

  ${MarketTag} {
    flex: 1;
    width: 100%;
  }
`;
